"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BonusConditionType = exports.BonusRegisterFailedReason = exports.BotBonusRecordStatus = exports.BotBonusFailReason = exports.BotBonusStatus = exports.StableCoin = void 0;
exports.StableCoin = ["USDT", "BUSD", "USDC"];
/** 发财金的状态 */
var BotBonusStatus;
(function (BotBonusStatus) {
    /** 未领取 */
    BotBonusStatus["un_collect"] = "un_collect";
    /** 未使用 */
    BotBonusStatus["un_use"] = "un_use";
})(BotBonusStatus || (exports.BotBonusStatus = BotBonusStatus = {}));
/** 领取用户发财金的失败状态 失败时返回 */
var BotBonusFailReason;
(function (BotBonusFailReason) {
    /** 需要实名认证 */
    BotBonusFailReason["need_kyc"] = "need_kyc";
    /** 过期 */
    BotBonusFailReason["bonus_expire"] = "bonus_expire";
    /** 发财金不存在 */
    BotBonusFailReason["bonus_not_exist"] = "bonus_not_exist";
    /** 首次入金不足 */
    BotBonusFailReason["first_deposit_not_enough"] = "first_deposit_not_enough";
    /** 累计入金不足 */
    BotBonusFailReason["cumulative_deposit_not_enough"] = "cumulative_deposit_not_enough";
    /** 活动过期 */
    BotBonusFailReason["task_expire"] = "task_expire";
    /** 超出预算 */
    BotBonusFailReason["exceed_budget"] = "exceed_budget";
    /** 存在未使用的发财金 */
    BotBonusFailReason["exist_not_used_bonus"] = "exist_not_used_bonus";
    /** 存在未领取的发财金 */
    BotBonusFailReason["exist_not_collect_bonus"] = "exist_not_collect_bonus";
    /** 重复领取 */
    BotBonusFailReason["duplicate_collect"] = "duplicate_collect";
})(BotBonusFailReason || (exports.BotBonusFailReason = BotBonusFailReason = {}));
/** 发财金使用记录 */
var BotBonusRecordStatus;
(function (BotBonusRecordStatus) {
    /** 已使用 */
    BotBonusRecordStatus["used"] = "used";
    /** 已过期  */
    BotBonusRecordStatus["expired"] = "expired";
    /** 未领取已过期  */
    BotBonusRecordStatus["uncollect_expired"] = "uncollect_expired";
})(BotBonusRecordStatus || (exports.BotBonusRecordStatus = BotBonusRecordStatus = {}));
/** 发财金报名失败原因 */
var BonusRegisterFailedReason;
(function (BonusRegisterFailedReason) {
    /** 活动时间无效 */
    BonusRegisterFailedReason["task_time_invalid"] = "task_time_invalid";
    /** 仅限邀请用户 */
    BonusRegisterFailedReason["only_invited"] = "only_invited";
    /** 仅限新用户 */
    BonusRegisterFailedReason["only_newly_user"] = "only_newly_user";
    /** 仅限交易过合约的用户 */
    BonusRegisterFailedReason["only_future_traded"] = "only_future_traded";
    /** 仅限未交易过合约的用户 */
    BonusRegisterFailedReason["only_no_future_traded"] = "only_no_future_traded";
})(BonusRegisterFailedReason || (exports.BonusRegisterFailedReason = BonusRegisterFailedReason = {}));
/** 发财金领取条件 */
var BonusConditionType;
(function (BonusConditionType) {
    /** first 首次入金 */
    BonusConditionType["deposit_first"] = "deposit_first";
    /** cumulative 累计入金 */
    BonusConditionType["deposit_cumulative"] = "deposit_cumulative";
})(BonusConditionType || (exports.BonusConditionType = BonusConditionType = {}));
